export const filterLoadedImages = (
  images: string[],
  loadedImages: string[]
): string[] => images.filter((i) => !loadedImages.includes(i));
